import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import Cookies from "js-cookie";
import md5 from 'js-md5';
import { getRandomString } from "@/utils/index"
import { get } from 'lodash'

const apikey = 'f6370cf1e3797893c96e252838fe0295'
axios.defaults.headers["Content-Type"] = "application/json";

// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: process.env.VUE_APP_BASE_API,
    baseURL: process.env.NODE_ENV === 'production' ? '/' : '/optic-api',
    // 超时
    timeout: 100000,
});
let setHeaders = function(config) {
    config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded', //  注意：设置很关键
        'wh-uuid': localStorage.getItem("WuhanWebUUID"),
        ...config.headers
    }
    config.headers["wh-token"] = Cookies.get("WuhanToken"); // 让每个请求携带自定义token 请根据实际情况自行修改
    const WHNoncestr = md5(localStorage.getItem("WuhanWebUUID") + new Date().getTime() + getRandomString(20))

    config.headers["wh-noncestr"] = WHNoncestr; // 让每个请求携带自定义token 请根据实际情况自行修改
    if (Cookies.get("WHTimestamp")) {
        const WHTimestamp = Date.parse(new Date())/1000 - parseInt(Cookies.get("WHTimestamp"))
        config.headers["wh-timestamp"] = WHTimestamp ; // 让每个请求携带自定义token 请根据实际情况自行修改
        let signStr =
            apikey +
            localStorage.getItem("WuhanWebUUID") +
            Cookies.get("WuhanToken") +
            config.method.toUpperCase() +
            config.url+
            WHTimestamp +
            WHNoncestr +
            JSON.stringify(config.data)
        // console.log(signStr)
        config.headers["wh-sign"] = md5(signStr).toUpperCase()
    }
}
// request拦截器
service.interceptors.request.use(
    // console.log("请求拦截器",config);
    (config) => {
        // 是否需要设置 token
        const isToken = (config.headers || {}).isToken === false;
        if (!localStorage.getItem("WuhanWebUUID")) {
            let GetUUidUrl = process.env.NODE_ENV === 'production' ? '/json/base/token' : '/optic-api/json/base/token';
            axios.post(GetUUidUrl, {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
                .then(res => {
                    if (res) {
                        const timestamp = Date.now();
                        const servertimestamp = res.data.data.timestamp * 1000;
                        const chazhi = servertimestamp - timestamp;
                        Cookies.set("Difference",chazhi);
                        if (localStorage.getItem("WuhanWebUUID") == res.data.data.uuid) {
                        } else {
                            localStorage.setItem("WuhanWebUUID",res.data.data.uuid);
                        }
                        Cookies.set("WuhanToken", res.data.data.token, 15);
                        Cookies.set("WHTimestamp", Date.parse(new Date()) / 1000 - res.data.data.timestamp);
                        window.location.reload();
                    }
                });
        }
        if(config.url=="/json/base/token"){
            config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded', //  注意：设置很关键
                'wh-uuid': localStorage.getItem("WuhanWebUUID") || ""
            };
        }
        if(config.url=="/ueditor/upload") {
            config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded', //  注意：设置很关键
                'wh-uuid': localStorage.getItem("WuhanWebUUID") || ""
            };
        }
        else{
            if (Cookies.get("WuhanToken")) {
                setHeaders(config)
            } else {
                // setTimeout(function() {
                // 在这里编写要延迟执行的代码

                //   store
                //   .dispatch("getwhUUid")
                //   .then(res => {
                //     setHeaders(config)
                //   })

                // }, 2000);


            }
        }

        //这些一定要带上？
        if (config.method === "get" && config.params) {
            let url = config.url + "?";
            for (const propName of Object.keys(config.params)) {
                const value = config.params[propName];
                var part = encodeURIComponent(propName) + "=";
                if (value && typeof value !== "undefined") {
                    if (typeof value === "object") {
                        for (const key of Object.keys(value)) {
                            let params = propName + "[" + key + "]";
                            // 后端要[] 但不要下标
                            if (config.customPatch) {
                                params = propName + "[]";
                            }
                            var subPart = encodeURIComponent(params) + "=";
                            url += subPart + encodeURIComponent(value[key]) + "&";
                        }
                    } else {
                        url += part + encodeURIComponent(value) + "&";
                    }
                }
            }
            url = url.slice(0, -1);
            config.params = {};
            config.url = url;
        }else{
            // TODO 在这里加上国际化的参数
            //console.log("xiaoxuxu",config.data);
            // config.data.token  =  token;

        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);



// 响应拦截器
service.interceptors.response.use(
    (res) => {
        // 未设置状态码则默认成功状态
        const code = res.data.rsp.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode["default"];
        if(res.data.rsp.code !== 0) {
            // Message({
            //   message: res.data.rsp.msg,
            //   type: "error",
            //   duration: 2 * 1000
            // });
        }
        return res.data;
        // if (code === 401) {
        //   store.dispatch("LogOut").then(() => {
        //     location.href = "/yhmt/login";
        //   });
        // } else if (code === 12100) {
        //   Notification.error({
        //     title: "用户名或密码错误",
        //   });
        // } else if (code === 12104) {
        //   Notification.error({
        //     title: "验证码错误",
        //   });
        // } else if (code === 12103) {
        //   Notification.error({
        //     title: "验证码已失效",
        //   });
        // } else if (code === 12101) {
        //   store.dispatch("LogOut").then(() => {
        //     location.href = "/yhmt/login";
        //   });
        // } else if (code === 500) {
        //   Message({
        //     message: msg,
        //     type: "error",
        //   });
        //   return Promise.reject(new Error(msg));
        // } else if (code !== 200) {
        //   Notification.error({
        //     title: msg,
        //   });
        //   return Promise.reject("error");
        // } else {
        //   return res.data;
        // }
    },
    (error) => {
        const status = get(error, 'response.status')//获取response的code
        let { message } = error;
        // Message({
        //   message: message,
        //   type: "error",
        //   duration: 2 * 1000,
        // });
        return Promise.reject(error);
        // }
    }
);

export default service;
